/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

export const MONTH_ABBR = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

export const SCAN_CHART_TIME_RANGE_SELECT_TYPE: {
  [key in string]: {
    name: string
    value: Redux.ScanResultInterval
    pendoTag: string
  }
} = {
  hour: {
    name: '24 hours',
    value: 'hour',
    pendoTag: 'SCAN_HISTORY_24HOUR',
  },
  '7days': {
    name: '7 days',
    value: '7days',
    pendoTag: 'SCAN_HISTORY_7DAY',
  },
  '14days': {
    name: '14 days',
    value: '14days',
    pendoTag: 'SCAN_HISTORY_14DAY',
  },
  '30days': {
    name: '30 days',
    value: '30days',
    pendoTag: 'SCAN_HISTORY_30DAY',
  },
}

export const ONE_HOUR_TS = 1000 * 60 * 60
export const ONE_DAY_TS = ONE_HOUR_TS * 24
